export default {
    name: 'Meno',
    tel: 'Telefón',
    save: 'Uložiť',
    confirm: 'Potvrdiť',
    cancel: 'Zrušiť',
    delete: 'Odstrániť',
    complete: 'Dokončiť',
    loading: 'Načítava sa...',
    telEmpty: 'Vyplňte telefónne číslo',
    nameEmpty: 'Vyplňte meno',
    nameInvalid: 'Neplatné meno',
    confirmDelete: 'Naozaj chcete odstrániť?',
    telInvalid: 'Neplatné telefónne číslo',
    vanCalendar: {
        end: 'Koniec',
        start: 'Začiatok',
        title: 'Kalendár',
        startEnd: 'Začiatok/Koniec',
        weekdays: ['Ne', 'Po', 'Ut', 'St', 'Št', 'Pi', 'So'],
        monthTitle: (year, month) => `${year}/${month}`,
        rangePrompt: (maxRange) => `Vyberte najviac ${maxRange} dní`,
    },
    vanCascader: {
        select: 'Vybrať',
    },
    vanContactCard: {
        addText: 'Pridať kontaktné informácie',
    },
    vanContactList: {
        addText: 'Pridať nový kontakt',
    },
    vanPagination: {
        prev: 'Predchádzajúci',
        next: 'Ďalší',
    },
    vanPullRefresh: {
        pulling: 'Potiahnite pre obnovenie...',
        loosing: 'Pustite pre obnovenie...',
    },
    vanSubmitBar: {
        label: 'Celkom：',
    },
    vanCoupon: {
        unlimited: 'Neobmedzené',
        discount: (discount) => `${discount * 10}% zľava`,
        condition: (condition) => `Minimálne ${condition}`,
    },
    vanCouponCell: {
        title: 'Kupón',
        tips: 'Žiadne kupóny',
        count: (count) => {
            if (count === 1) return `Máte 1 kupón`;
            if (count >= 2 && count <= 4) return `Máte ${count} kupóny`;
            return `Máte ${count} kupónov`;
        },
    },
    vanCouponList: {
        empty: 'Žiadne kupóny',
        exchange: 'Vymeniť',
        close: 'Zavrieť',
        enable: 'Dostupné',
        disabled: 'Nedostupné',
        placeholder: 'Kód kupónu',
    },
    vanAddressEdit: {
        area: 'Oblasť',
        postal: 'PSČ',
        areaEmpty: 'Vyberte doručovaciu oblasť',
        addressEmpty: 'Adresa nemôže byť prázdna',
        postalEmpty: 'Neplatné PSČ',
        defaultAddress: 'Nastaviť ako predvolenú adresu',
        telPlaceholder: 'Telefón',
        namePlaceholder: 'Meno',
        areaPlaceholder: 'Oblasť',
    },
    vanAddressEditDetail: {
        label: 'Adresa',
        placeholder: 'Adresa',
    },
    vanAddressList: {
        add: 'Pridať novú adresu',
    },
};